module.exports = __webpack_public_path__ + "img/travel6.5c774d59.jpg";